import { createSelector } from "reselect";
import { sortCompare } from "~/utils/utils";

export const getAllJobTypes = (state) => state.job_types;
export const getAllJobTypesArray = createSelector(getAllJobTypes, (jobTypes) => Object.values(jobTypes));
export const getJobTypeById = (state, id) => {
  return state.job_types[`${id}`];
};

export const getActiveJobTypesArrayOfIdAndNameSelector = createSelector(getAllJobTypesArray, (jobTypes) =>
  jobTypes
    .reduce((prev, next) => {
      if (!next.is_archived) {
        prev.push({ id: next.id, name: next.name });
      }
      return prev;
    }, [])
    .sort((a, b) => a.name.localeCompare(b.name))
);

export const getActiveJobTypesSortedByName = createSelector(getAllJobTypesArray, (jobTypes) => {
  return jobTypes.filter((j) => !j.is_archived).sort((a, b) => a.name.localeCompare(b.name));
});

export const getJobTypesWithIdsAndNames = createSelector(getActiveJobTypesSortedByName, (jobTypes) => {
  return jobTypes.reduce((acc, current) => {
    acc[current.id] = current.name;
    return acc;
  }, {});
});

export const getDefaultJobType = createSelector(getAllJobTypesArray, (allJobTypes) => {
  return allJobTypes.find((jobType) => {
    return jobType.is_default && !jobType.is_archived;
  });
});

export const getDefaultJobTypeName = createSelector(getDefaultJobType, (defaultJobType) =>
  defaultJobType ? defaultJobType.name : ""
);

export const getSelectedJobTypeName = createSelector(getJobTypeById, getDefaultJobTypeName, (selected, defaultName) =>
  selected ? selected.name : defaultName
);

export const getJobTypesByIds = createSelector(
  getAllJobTypes,
  (_state, ids) => ids,
  (jobTypes, ids) => {
    return ids
      .map((id) => {
        if (jobTypes[id]) {
          return { id, name: jobTypes[id].name };
        }
      })
      .filter(Boolean)
      .sort((a, b) => sortCompare(a.name.toLowerCase(), b.name.toLowerCase()));
  }
);

export const getIsInitialJobTypes = createSelector(
  getActiveJobTypesSortedByName,
  getDefaultJobType,
  (activeJobTypes, defaultJobType) => activeJobTypes.length === 1 && !defaultJobType?.updated_on
);
